const Backbone = require('backbone');
const AccordionList = require('app/views/store/common/accordion_list');
const FacetGroupView = require('app/views/store/pages/categories/facet_group');
const FacetGroupsExpandStatuses = require('app/models/store/client/category/facetGroupsExpandStatuses');
const window = require('window');
const dustjs = require('dustjs');
const _noResultsDust = require('common/_no_results.dust');
const _facetGroupDustLDI = require('store/themes/livingdirect/global/pages/categories/_facet_group.dust');
const _mobileFacetGroupDustLDI = require('store/themes/livingdirect/global/pages/categories/_mobile_facet_group.dust');
const _facetGroupDustSelectsLDI = require('store/themes/livingdirect/global/pages/categories/_facet_group_selects.dust');
const FacetList = AccordionList.extend({
	childViewEvents: {
		'click .js-remove-facet': '_removeSelectedFacet'
	},

	initialize(options = {}) {
		this.options = options;

		AccordionList.prototype.initialize.call(
			this,
			Object.assign(
				{
					multiExpand: true,
					exception: 'js-help-icon'
				},
				this.options
			)
		);

		this.listenTo(this.collection, 'update', this._onCollectionUpdate.bind(this));
		this.listenTo(Backbone, 'accordion_list:toggle', this._toggleGroupExpanded.bind(this));

		this.listenTo(Backbone, 'accordion_list:collapse', this._setFacetGroupsExpandStatuses.bind(this));
		this.listenTo(Backbone, 'accordion_list:expand', this._setFacetGroupsExpandStatuses.bind(this));

		this.listenTo(Backbone, 'facets:expand_all', this._expandAllFacets.bind(this));
		this.listenTo(Backbone, 'facets:collapse_all', this._collapseAllFacets.bind(this));
	},

	_onCollectionUpdate() {
		this.render();
		if (this.collection.info) {
			this._toggleNoResultsMessage(this.collection.info.count > 0);
		}
	},

	render() {
		this.$el.empty();
		this._removeFacetGroupViews();
		this.facetGroupViews = [];
		this.collection.each((facetGroupModel) => {
			this._conditionalCollapseGroupBeforeRender(facetGroupModel);
			const facetViewOptions = this._getFacetGroupViewOptions(facetGroupModel),
				facetGroupView = new FacetGroupView(facetViewOptions);
			this.$el.append(facetGroupView.render().el);
			this.facetGroupViews.push(facetGroupView);
		});
		return this;
	},

	_getFacetGroupViewOptions(facetGroupModel) {
		if (window.BCOM.theme.isLivingDirect) {
			if (window.BCOM.device.isDesktop) {
				return {
					model: facetGroupModel,
					tagName: 'div',
					template: this.options.isFacetListWithSelects ? _facetGroupDustSelectsLDI : _facetGroupDustLDI
				};
			} else {
				return {
					model: facetGroupModel,
					template: _mobileFacetGroupDustLDI
				};
			}
		} else {
			return {
				model: facetGroupModel
			};
		}
	},

	_toggleGroupExpanded(groupName) {
		this.collection.trigger('facets:groups:collapse', groupName);
	},

	_conditionalCollapseGroupBeforeRender(facetGroupModel) {
		if (this.options.startCollapsed && !facetGroupModel.get('selected')) {
			facetGroupModel.set('isCollapsed', true);
		}
	},

	_removeFacetGroupViews() {
		if (this.facetGroupViews && this.facetGroupViews.length) {
			this.facetGroupViews.forEach((view) => {
				view.trigger('removeyourself');
			});
		}
	},

	_toggleNoResultsMessage(hasResults) {
		if (hasResults) {
			this.$('.js-no-results').remove();
		} else {
			dustjs.render(
				_noResultsDust,
				{},
				function(err, markup) {
					this.$el.append(`<li class="js-no-results no-results pad-content">${markup}</li>`);
				}.bind(this)
			);
		}
	},

	facetGroupExpandStatusModel: new FacetGroupsExpandStatuses(),

	_setFacetGroupsExpandStatuses: function($item) {
		this.facetGroupExpandStatusModel.addGroup({
			pageType: window.dataLayer.categoryId ? 'category' : 'search',
			categoryId: window.dataLayer.categoryId,
			searchTerm: window.dataLayer.search ? window.dataLayer.search.name : '',
			groupName: $item.data('groupname'),
			isExpanded: $item.hasClass('active')
		});

		this.facetGroupExpandStatusModel.save();
	},

	_expandAllFacets: function() {
		this.$el.find('.js-group').each((index, element) => {
			this.facetGroupExpandStatusModel.addGroup({
				pageType: window.dataLayer.categoryId ? 'category' : 'search',
				categoryId: window.dataLayer.categoryId,
				searchTerm: window.dataLayer.search ? window.dataLayer.search.name : '',
				groupName: $(element).data('groupname'),
				isExpanded: true
			});
		});

		this.$el.find('.js-group').addClass('active');

		this.facetGroupExpandStatusModel.save();
	},

	_collapseAllFacets: function() {
		this.$el.find('.js-group').each((index, element) => {
			this.facetGroupExpandStatusModel.addGroup({
				pageType: window.dataLayer.categoryId ? 'category' : 'search',
				categoryId: window.dataLayer.categoryId,
				searchTerm: window.dataLayer.search ? window.dataLayer.search.name : '',
				groupName: $(element).data('groupname'),
				isExpanded: false
			});
		});

		this.$el.find('.js-group').removeClass('active');

		this.facetGroupExpandStatusModel.save();
	}
});

module.exports = FacetList;
